import { t } from "i18next";
import { ModalPopup } from "../common";
import SmallLoader from "../loaders/SmallLoader";
import { UserContextInterface } from "../../state/UserContext";

interface SigningOffTheJourneyPopupProps {
  isOpen: boolean;
  userContext: UserContextInterface;
  onOpenChange(open: boolean): void;
}

export const SigningOffTheJourneyPopup = ({
  isOpen,
  userContext,
  onOpenChange,
}: SigningOffTheJourneyPopupProps) => {
  return (
    <ModalPopup
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      title={t("Pages.CollabDocs.Popup.SigningOffTheJourney.Title")}
      showCloseIcon={false}
      width="TINY"
    >
      <div className="text-center pt-4">
        <SmallLoader colour={userContext.user.client.accentHexColour} />
        <p className="mt-4 mb-2">
          {t("Pages.CollabDocs.Popup.SigningOffTheJourney.Body")}
        </p>
      </div>
    </ModalPopup>
  );
};

export default SigningOffTheJourneyPopup;
